module.exports = __webpack_public_path__ + "static/media/download.8452503e.svg";